import * as React from "react";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { AppUser } from "../../models/appUser";
import { LoadPage } from "../LoadPage";
import { Switch } from "@progress/kendo-react-inputs";
import { useThemeSwitcher } from "react-css-theme-switcher";

interface UserFormProps {
    isLoading: boolean,
    appUser?: AppUser,
    onChange_AppUser: Function,
    children?: React.ReactNode
}

export const UserForm = (props: UserFormProps) => {
    const { switcher, currentTheme, themes } = useThemeSwitcher();
    const toggleTheme = (event: any) => {
        props.onChange_AppUser(event, 'DarkMode');
        switcher({ theme: props.appUser?.DarkMode ? themes.dark : themes.light });
    };

    const hideThemeSwapper = true;

    return <LoadPage isLoading={props.isLoading}>
        <Form initialValues={props.appUser} key={JSON.stringify(props.appUser)} render={() => (
            <>
                <FormElement>
                    <fieldset className={'k-form-fieldset m-4'}>

                        {!hideThemeSwapper &&
                            <div className="row">
                                <div className="p-1 col">
                                    <h2>The current theme is: {currentTheme}</h2>
                                    <Switch defaultChecked={props.appUser?.DarkMode} onChange={toggleTheme} />
                                </div>
                            </div>}

                        <div className="row">
                            <div className="p-1 col">
                                <Field name={'Name'} component={Input} label={'Name'} required={false} onChange={(event) => props.onChange_AppUser(event, 'Name')} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="p-1 col">
                                <Field name={'Email'} component={Input} label={'Email'} required={false} onChange={(event) => props.onChange_AppUser(event, 'Email')} />
                            </div>
                        </div>

                    </fieldset>

                    <br /><br />

                </FormElement>
            </>
        )} />
    </LoadPage>
}